import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const embeddedWhiteboardModalEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-embedded-confluence-whiteboard-modal" */ '.'),
	),
	getPreloadProps: () => ({}),
});
